import React from 'react';
import { Globe, Cpu, Palette, Smartphone, Search, Megaphone } from 'lucide-react';

export const SERVICES_DATA = [
  {
    slug: 'web-development',
    icon: <Globe size={32} />, 
    title: 'Web Development',
    headline: 'WEBSITES THAT PERFORM, NOT JUST IMPRESS.',
    desc: 'We build fast, scalable, conversion-optimized websites using modern technologies. From landing pages to complex web applications — we handle it all.',
    features: ['Custom website development','WordPress & Shopify','React, Next.js & modern frameworks','REST API & backend development','Performance & speed optimization','Mobile-first responsive design'],
    img: require('../images/b1.webp'),
    imgAlt: 'Web development code on screen',
    tag: 'Most Popular',
  },
  {
    slug: 'ai-automation',
    icon: <Cpu size={32} />, 
    title: 'AI & Automation',
    headline: 'WORK SMARTER. AUTOMATE EVERYTHING.',
    desc: 'Transform repetitive tasks into automated workflows with AI-powered solutions. From intelligent chatbots to business process automation, we help companies save time, reduce costs, and scale faster with modern AI technology.',
    features: ['AI Chatbots & Virtual Assistants','Business Process Automation','Lead Generation & CRM Automation','AI Content & Marketing Workflows','Custom AI Tools & Integrations','OpenAI, Claude & Gemini Solutions'],
    img: require('../images/ai-automation.webp'),
    imgAlt: 'AI automation dashboard and intelligent workflow systems',
    tag: 'Trending'
  },
  {
    slug: 'ui-ux-design',
    icon: <Palette size={32} />, 
    title: 'Web Design',
    headline: 'DESIGN THAT CONVERTS VISITORS INTO CUSTOMERS.',
    desc: 'Great design is not just about looking good — it is about guiding users to take action. We create premium UI/UX designs that reflect your brand and drive measurable results.',
    features: ['UI/UX design & wireframing','Brand identity & logo design','Figma prototyping & design systems','Landing page design','Conversion rate optimized layouts','Motion & interaction design'],
    img: require('../images/b2.webp'),
    imgAlt: 'UI UX design on tablet',
    tag: null,
  },
  {
    slug: 'app-development',
    icon: <Smartphone size={32} />, 
    title: 'App Development',
    headline: 'MOBILE APPS YOUR USERS WILL LOVE.',
    desc: 'From idea to App Store — we build cross-platform mobile apps for iOS and Android that are fast, reliable, and built to scale with your business.',
    features: ['React Native cross-platform apps','Flutter app development','iOS & Android native apps','App UI/UX design','App Store & Play Store deployment','Ongoing maintenance & updates'],
    img: require('../images/b3.webp'),
    imgAlt: 'Mobile app development',
    tag: null,
  },
  {
    slug: 'seo',
    icon: <Search size={32} />, 
    title: 'SEO',
    headline: 'RANK HIGHER. GET FOUND. GROW ORGANICALLY.',
    desc: 'We help your business climb search rankings and stay there. Our data-driven SEO strategies are built for long-term growth — not quick hacks that fade.',
    features: ['Technical SEO audit & fixes','On-page & off-page optimization','Keyword research & strategy','Local SEO & Google My Business','Content strategy & creation','Monthly reporting & analysis'],
    img: require('../images/b4.webp'),
    imgAlt: 'SEO analytics dashboard',
    tag: null,
  },
  {
    slug: 'digital-marketing',
    icon: <Megaphone size={32} />, 
    title: 'Digital Marketing',
    headline: 'CLICKS THAT TURN INTO ACTUAL CUSTOMERS.',
    desc: 'We run full-funnel digital marketing campaigns across search, social, and email. Every rupee you spend is tracked, optimized, and working toward your business goals.',
    features: ['Google Ads & PPC campaigns','Meta (Facebook & Instagram) Ads','Social media management','Email marketing & automation','Content marketing & blogs','Analytics & conversion tracking'],
    img: require('../images/b5.webp'),
    imgAlt: 'Digital marketing strategy',
    tag: null,
  },
];
